import React, { createContext, useEffect, useState } from 'react';
import { isDesktopSize, isMobileSize } from './utils';
import { mobileMaxMediaQuery } from './constants';

export const ScreenSizeContext = createContext({
  isMobile: true,
  isDesktop: false,
});

interface Props {
  children: React.ReactNode;
}

export default function ScreenSizeProvider({ children }: Props) {
  const [screenSize, setScreenSize] = useState({
    isMobile: isMobileSize(),
    isDesktop: isDesktopSize(),
  });

  useEffect(() => {
    const resizeCb = () =>
      setScreenSize({
        isMobile: isMobileSize(),
        isDesktop: isDesktopSize(),
      });

    window.matchMedia(mobileMaxMediaQuery).addEventListener('change', resizeCb);

    return () => {
      window.matchMedia(mobileMaxMediaQuery).removeEventListener('change', resizeCb);
    };
  }, []);

  return <ScreenSizeContext.Provider value={screenSize}>{children}</ScreenSizeContext.Provider>;
}
